export default __webpack_public_path__ + "static/media/cat_in_the_city.cb923443.jpg";